
<template>
  <thead class="table-header">
    <tr class="header-row">
      <HeaderCell
        v-if="allowSelection"
        :namespace="namespace"
        :all-rows-selected="allRowsSelected"
        :column="{ name: 'selectRow', width: '30px', align: 'centered' }"
        selectable
        @selected-all="(value) => $emit('selectedAll', value)"
      />
      <HeaderCell
        v-for="(column, index) in columns"
        :key="index"
        :column="column"
        :namespace="namespace"
        :active="sortedColumnIndex === index"
        @on-sort="$emit('onSortChange', index)"
      />
    </tr>
  </thead>
</template>

<script>
import HeaderCell from './HeaderCell.vue';

export default {
  name: 'TableHeader',
  components: {
    HeaderCell,
  },
  props: {
    allowSelection: { type: Boolean, default: false },
    columns: { type: Array, default: () => [] },
    sortedColumnIndex: { type: Number, default: -1 },
    namespace: { type: String, required: true },
    allRowsSelected: { type: Boolean, default: false },
  },
  emits: ['selectedAll', 'onSortChange'],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss">

// .table-header {
//   .header-row {
//     background-color: #F7F9FA;
//   }
// }

</style>
